import RoofSnapApiClient from "./roofSnapApiClient";

const baseUrl = 'userprofiles';

class UserProfileClient extends RoofSnapApiClient {
    async getUserProfiles(params) {
        const { queryParams } = params;
        const url = `${baseUrl}/${queryParams}`;
        const userProfiles = await super.get(url);
        return userProfiles;
    }

    async getUserProfile(params) {
        const { id } = params;
        const url = `${baseUrl}/${id}`;
        const userProfile = await super.get(url);
        return userProfile;
    }

    async getUsersRoles(params) {
        const { id } = params;
        const url =  `${baseUrl}/${id}/roles`;
        const userRoles = await super.get(url);
        return userRoles;
    }

    async getRequestedSketchOrders(params) {
        const { id, queryParams } = params;
        const url = `${baseUrl}/${id}/requestedsketchorders${queryParams}`;
        const sketchOrders = await super.get(url);
        return sketchOrders;
    }

    async getOwnedSketchOrders(params) {
        const { id, queryParams } = params;
        const url = `${baseUrl}/${id}/ownedsketchorders${queryParams}`;
        const sketchOrders = await super.get(url);
        return sketchOrders;
    }
}

export default UserProfileClient;
